import React, { useState, useEffect } from 'react';

import Header from '../Header.js';
import Footer from '../Footer.js';
import AgencyListBox from '../boxes/AgencyListBox.js';

const AgencyListPage = ({ user }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1600); // screen width cutoff
        };
    
        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <Header 
                user={user} 
                buttonsVisible={{
                    homeButton: true
                }}
                pageTitle="Agency Management"
            />
            <div className='box-spacer'/>
            <AgencyListBox user={user} isSmallScreen={isSmallScreen}/>
            <Footer />
        </div>
    );
};

export default AgencyListPage; 